import './linkable-list.scss';
import AHref from "../ahref/ahref";
import FontBody2 from '../fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../fonts/font-props';
import useDashboardTranslation from '../../dashboard-translation/hooks/dashboard-translation-hook';

interface ILinkList {
    label: string;
    href: string;
}

interface ILinkableProps {
    list: ILinkList[];
    totalCount: number;
    totalRemainingItemsLinkHref?: string;
}

interface ILinkableListRemainingItemsProps {
    totalRemainingItemsCount: number;
    totalRemainingItemsLinkHref?: string;
}

/*
  Example usage #1:
  <LinkableList
    totalCount={totalCount!}
    list={list}
    />

  Example usage #2 (with href for link element that is defined by <LinkableList /> and not the consumer):
    <LinkableList
        totalCount={totalCount!}
        list={list}
        totalRemainingItemsLinkHref={config.apiUrl + '/dashboard/returns?search_input=' + customerStore?.denormalizedId}
     />
    
*/

const RemainingItems: React.FC<ILinkableListRemainingItemsProps> = (({ totalRemainingItemsCount, totalRemainingItemsLinkHref }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';
    if (totalRemainingItemsCount === 0) {
        if (!totalRemainingItemsLinkHref) {
            return null;
        }

        return (
            <AHref href={totalRemainingItemsLinkHref} target={'_blank'}>
                <FontBody2 color={FONT_COLOR.ACCENT1}>
                    {getTranslation('VIEW_ALL', pageScope)}
                </FontBody2>
            </AHref>
        );
    }

    return totalRemainingItemsLinkHref
        ?   <AHref href={totalRemainingItemsLinkHref} target={'_blank'}>
                <FontBody2 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.BOLD}>+{totalRemainingItemsCount}</FontBody2>
            </AHref>
        :   <span>+{totalRemainingItemsCount}</span>;
});

const LinkableList: React.FC<ILinkableProps> = (({list, totalCount, totalRemainingItemsLinkHref}) => {
    const listLength = list.length;
    const totalRemainingItemsCount = totalCount - listLength;
    return (
        <div className={'linkable-list'}>
            {list.map((item, index) => (
                item.href
                    ?   <AHref href={item.href} key={index} target={'_blank'}>
                            {item.label}
                            {index !== listLength && index !== (listLength -1) ? ', ' : ''}
                        </AHref>
                    :   item.label
            ))}
            
            <RemainingItems totalRemainingItemsCount={totalRemainingItemsCount} totalRemainingItemsLinkHref={totalRemainingItemsLinkHref} />
        </div>
    );
});
export default LinkableList;